module.exports = __webpack_public_path__ + "img/pic-Visualinspection.179c712f.jpg";